var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.221,
    height: 18.216,
    viewBox: "0 0 18.221 18.216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "home",
    transform: "translate(-3.374 -3.375)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_319",
    "data-name": "Path 319",
    d: "M13.865,7.3a.172.172,0,0,0-.219,0L6.816,12.76a.184.184,0,0,0-.066.136V22.967a.088.088,0,0,0,.088.088h4.729a.088.088,0,0,0,.088-.088v-6.13a.088.088,0,0,1,.088-.088H15.77a.088.088,0,0,1,.088.088v6.13a.088.088,0,0,0,.088.088h4.729a.088.088,0,0,0,.088-.088V12.9a.177.177,0,0,0-.066-.136Z",
    transform: "translate(-1.274 -1.464)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_320",
    "data-name": "Path 320",
    d: "M21.358,10.215,13.082,3.585a.961.961,0,0,0-1.2,0l-3.6,2.929V4.667a.088.088,0,0,0-.088-.088H5.564a.088.088,0,0,0-.088.088V8.7l-1.87,1.537a.613.613,0,0,0-.053.915.609.609,0,0,0,.433.18.617.617,0,0,0,.385-.136l8.053-6.481a.078.078,0,0,1,.057-.018.106.106,0,0,1,.057.018l8.053,6.454a.617.617,0,0,0,.385.136.621.621,0,0,0,.617-.648A.622.622,0,0,0,21.358,10.215Z",
    transform: "translate(0)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.de4687d29c55579a38ea76dfe9721ced.svg";
export { ForwardRef as ReactComponent };